export function cmToTwips(cm) {
  const v = parseFloat(cm || 0);
  if (isNaN(v)) return 0;
  return Math.round(v * 567);
}

export function twipsToCm(twips) {
  const t = parseFloat(twips || 0);
  if (isNaN(t)) return '0.00';
  return (t / 567).toFixed(2);
}
